/** The inline question shown before the salaried flag changes. */
import type { Ref } from 'react';

const BUTTON = 'min-h-[24px] min-w-[24px] rounded px-2 text-xs';
const FOCUS =
  'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-moss-500';

export default function SalariedConfirm({
  memberName,
  makeSalaried,
  busy,
  confirmRef,
  onConfirm,
  onCancel,
}: {
  memberName: string;
  makeSalaried: boolean;
  busy: boolean;
  confirmRef: Ref<HTMLButtonElement>;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return (
    <div className="flex flex-wrap items-center gap-2 rounded border border-stone-200 dark:border-stone-700 px-3 py-1.5">
      <span className="text-stone-700 dark:text-stone-300">
        {makeSalaried
          ? `Mark ${memberName} as salaried? Per-shift rates will show as a dash.`
          : `Mark ${memberName} as paid per shift?`}
      </span>
      <button
        ref={confirmRef}
        type="button"
        disabled={busy}
        onClick={onConfirm}
        className={`${BUTTON} ${FOCUS} bg-moss-600 text-white hover:bg-moss-700 disabled:opacity-50`}
      >
        Confirm
      </button>
      <button
        type="button"
        onClick={onCancel}
        className={`${BUTTON} ${FOCUS} text-stone-700 dark:text-stone-300 hover:underline`}
      >
        Cancel
      </button>
    </div>
  );
}
